module.exports = "<div class=\"subscribe-button\">\r\n  <div class=\"logo\">\r\n    <a  target=\"_blank\" href=\"https://es.surveymonkey.com/r/ZK3FHZM\"><img class=\"small zoom-in-out \" src=\"/assets/img/opinar.png\" alt=\"\">\r\n    </a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/subscribe-button/subscribe-button.component.html
// module id = ../../../../../src/app/subscribe-button/subscribe-button.component.html
// module chunks = main